export const tooltipSettings = {
  theme: 'klik',
  delay: 2000,
  placement: 'bottom',
};
